export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EMAIL_VALIDATION_MESSAGE = 'Email Address must be a valid email';
